<script lang="ts">
  import { getApiKey, setApiKey } from "../lib/storage";
  import { pingAuth } from "../lib/wegli";

  export let onClose: () => void;

  let value = getApiKey();
  let status: "idle" | "checking" | "ok" | "bad" = "idle";
  let message = "";

  async function save() {
    setApiKey(value);
    status = "checking";
    message = "Prüfe Schlüssel…";
    try {
      const ok = await pingAuth();
      if (ok) {
        status = "ok";
        message = "Schlüssel gültig.";
      } else {
        status = "bad";
        message = "Schlüssel abgelehnt (401).";
      }
    } catch (e) {
      status = "bad";
      message = e instanceof Error ? e.message : "Fehler";
    }
  }
</script>

<div class="wrap">
  <header>
    <h2>Einstellungen</h2>
    <button type="button" on:click={onClose}>Schließen</button>
  </header>

  <label>
    weg.li API-Key
    <input type="text" bind:value autocomplete="off" spellcheck="false" placeholder="z. B. 17a02fb1…" />
  </label>
  <p class="hint">Profil → API-Key auf weg.li. Wird nur lokal im Browser gespeichert.</p>

  <button type="button" on:click={save} disabled={!value || status === "checking"}>Speichern & prüfen</button>

  {#if message}
    <p class="status {status}">{message}</p>
  {/if}
</div>

<style>
  .wrap { display: flex; flex-direction: column; gap: 14px; padding: 20px; max-width: 640px; margin: 0 auto; }
  header { display: flex; justify-content: space-between; align-items: center; }
  h2 { margin: 0; font-size: 1.25rem; }
  label { display: flex; flex-direction: column; gap: 6px; font-size: 0.9rem; color: var(--muted); }
  .hint { color: var(--muted); font-size: 0.85rem; margin: 0; }
  .status.ok { color: var(--accent); }
  .status.bad { color: var(--err); }
  .status.checking { color: var(--muted); }
</style>
